import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UploadFile, UploadEvent, FileSystemFileEntry } from 'ngx-file-drop';

@Component({
  selector: 'app-ag-upload-temporal-files',
  templateUrl: './ag-upload-temporal-files.component.html',
  styleUrls: ['./ag-upload-temporal-files.component.scss']
})
export class AgUploadTemporalFilesComponent implements OnInit {

  @Input() TasacionID: number = 0;

  @Input() TipoArchivo: string;
  @Input() EstanciaId: string;
  @Input() Version: string;
  @Input() isFromEntityType: boolean = false;
  @Input() entityType: any;
  @Input() entityId: any;

  private myAppUrl: string;
  public droppedFiles: any[] = [];

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    this.myAppUrl = this.baseUrl;
  }


  ngOnInit() {
  }

  public droppedMultiple(event: UploadEvent) {
    // const droppedFiles: any = [];
    let completedFileCount = 0;
    // this.droppedFiles = [];

    event.files.forEach(droppedFile => {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.droppedFiles.push(file);
          completedFileCount++;
          console.log(file)
          // if (completedFileCount === event.files.length) {
          //   // this.sendMultipleFiles();
          //   this.FileUploaded.emit(this.droppedFiles);
          // }
        })


      }
    });

  }

  sendMultipleFiles() {
    if (this.droppedFiles.length != 0) {
      const formData = new FormData();
      // Headers
      const headers = new HttpHeaders({
        'security-token': 'mytoken'
      });

      if (this.isFromEntityType) {
        formData.append('entityId', this.entityId.toString());
        formData.append('entityType', this.entityType);

        this.droppedFiles.forEach(file => {
          formData.append('files', file, file.name);
        });
        if (formData.getAll('files').length === this.droppedFiles.length) {

          this.http.post(this.myAppUrl + 'api/File', formData, {
            headers: headers,
            responseType: 'blob',
            // params: params  
          }).subscribe(data => {
          });
        }
      } else {
        formData.append('TasaID', this.TasacionID.toString());
        formData.append('TipoArchivo', this.TipoArchivo);
        formData.append('EstanciaID', this.EstanciaId);
        formData.append('Version', this.Version);

        this.droppedFiles.forEach(file => {
          formData.append('tasaFiles', file, file.name);
        });

        if (formData.getAll('tasaFiles').length === this.droppedFiles.length) {
          this.http.post(this.myAppUrl + 'api/tasaciones/fileUpload', formData, { headers: headers, responseType: 'blob' })
            .subscribe(data => {
              // Sanitized logo returned from backend
              // this.FileUploaded.emit();
            });
        }
      }
    }

    this.droppedFiles = [];
  }



  onMultipleFilesChanged(event: Event) {

    const inputElement = event.target as HTMLInputElement;

    const fileList: FileList = inputElement.files;
    this.droppedFiles.push(...Array.from(fileList))

  }

  onClickSubmit(tasacionID: any = null) {
    if (this.isFromEntityType == false) {
      this.TasacionID = tasacionID;
    } else {
      this.entityId = tasacionID;
    }

    this.sendMultipleFiles();
  }

  removeFile(index) {
    this.droppedFiles.splice(index, 1);
  }



}
